import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-booking-terms',
    template: `
        <div>
            <embed src="/assets/files/booking-terms.pdf" style="position: absolute; height: 100%; width: 100%" type="application/pdf">
        </div>
    `,
})
export class BookingTermsComponent implements OnInit {
    ngOnInit() {
    }
}
